import { msg } from "@lingui/core/macro";

export const disableCancelPermitRuleMessages = {
	name: msg({ message: "Parkers Can Cancel" }),
	description: msg({ message: "Parkers can cancel their own permit" }),
	errors: {
		disabled: msg({ message: "Cancel permit is not enabled for this event." }),
	},
} as const;
